import React, { Component } from "react";
import * as Constants from "../../Constants/index"
import axios from "axios";
import swal from "sweetalert";
import SimpleReactValidator from "simple-react-validator";
import { getAllByPlaceholderText } from "@testing-library/react";
import { join } from "draft-js/lib/DefaultDraftBlockRenderMap";
import LoadingButton from "../common/LoadingButton";
// import SimpleReactValidator from "simple-react-validator";
// import Switch from "react-switch";
// import ReactDragListView from "react-drag-listview";

class CreateProgramManagers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: this.props.resp ? this.props.resp.data.output.name : '',
      email: this.props.resp ? this.props.resp.data.output.email : '',
      mobile: this.props.resp ? this.props.resp.data.output.mobile : '',
      password: this.props.resp ? this.props.resp.data.output.password : '',
      mobileWhatsApp: this.props.resp ? this.props.resp.data.output.mobileWhatsApp : '',
      designation: this.props.resp ? this.props.resp.data.output.designation : '',
      doa: this.props.resp ? this.props.resp.data.output.doa : '',
      marital: this.props.resp ? this.props.resp.data.output.marital : '',
      sex: this.props.resp ? this.props.resp.data.output.sex : '',
      parentId: this.props.resp ? this.props.resp.data.output.parentId : '',

      userType: this.props.resp ? (this.props.resp.data.output.salesUserType || this.props.resp.data.output.userType || '') : '',
      parentType: this.props.resp ? this.props.resp.data.output.parentType : '',
      userJobTitle: this.props.resp ? this.props.resp.data.output.userJobTitle : '',
      userRegion: this.props.resp ? this.props.resp.data.output.userRegion : '',
      userBranch: this.props.resp ? this.props.resp.data.output.userBranch : '',

      states: [],
      citys: [],
      districts: [],
      // selectedStates: [],
      // selectedCitys: [],
      // selectedDistricts: [],
      selectedStates: this.props.resp ? this.props?.resp?.data?.output?.sStateId?.split(',') : [],
      selectedCitys: this.props.resp ? this.props?.resp?.data?.output?.sCityId?.split(',') : [],
      selectedDistricts: this.props.resp ? this.props?.resp?.data?.output?.sDistrictId?.split(',') : [],
      parents: [],
      regions: [],
      branches: [],
      areas: [],
      limit: 1000,
      totalResults: 0,
      sortBy: 'name',
      search: '',
      page: 1,
      spincode: this.props.resp ? this.props.resp.data.output.spincode : "",
      pincodes: [],
      salesUserType: this.props.resp ? (this.props.resp.data.output.salesUserType || this.props.resp.data.output.userType || '') : "",
      cluster: this.props.resp ? (this.props.resp.data.output.cluster || "") : "",
      territory: this.props.resp ? (this.props.resp.data.output.territory || "") : "",
      zone: this.props.resp ? (this.props.resp.data.output.zone || "") : "",
      headquater: this.props.resp ? (this.props.resp.data.output.headquater || "") : "",
      designation: this.props.resp ? (this.props.resp.data.output.designation || "") : "",
      hqDesignation: this.props.resp ? (this.props.resp.data.output.hqDesignation || "") : "",
      submitting: false,
    };
    this.validator = new SimpleReactValidator()
  }

  convertToIntegerArray = () => {
    const selectedStates = (this.state.selectedStates || []).map(numStr => parseInt(numStr, 10));
    const selectedDistricts = (this.state.selectedDistricts || []).map(numStr => parseInt(numStr, 10));
    const selectedCitys = (this.state.selectedCitys || []).map(numStr => parseInt(numStr, 10));

    this.setState({ selectedStates, selectedDistricts, selectedCitys });
  };

  // convertToIntegerArray = () => {
  //   const selectedStates = this.state.selectedStates.map(numStr => parseInt(numStr, 10));
  //   this.setState({ selectedStates });
  //   const selectedDistricts = this.state.selectedDistricts.map(numStr => parseInt(numStr, 10));
  //   this.setState({ selectedDistricts });
  //   const selectedCitys = this.state.selectedCitys.map(numStr => parseInt(numStr, 10));
  //   this.setState({ selectedCitys });
  // };

  componentDidMount() {
    this.convertToIntegerArray();

    if (this.props.resp) {
      const selectedType = this.props.resp.data.output.salesUserType || this.props.resp.data.output.userType;
      if (selectedType) {
        this.SALESRequest(selectedType);
      }
    }
    const StatesRequest = async () => {
      try {
        const token = localStorage.getItem("token");
        let url = "";
        this.state.search !== ""
          ? (url =
            "master/geography/state?" +
            "name=" +
            this.state.search +
            "&sortBy=" +
            this.state.sortBy +
            "&limit=" +
            this.state.limit +
            "&page=" +
            this.state.page)
          : (url =
            "master/geography/state?sortBy=" +
            this.state.sortBy +
            "&limit=" +
            this.state.limit +
            "&page=" +
            this.state.page);
        const resp = await axios
          .get(Constants.api + url, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((resp) => {
            //  casetype array

            if (resp.status === 201 && resp.data.result !== 'error') {
              console.log(resp.data.output.results);
              this.setState({
                states: resp.data.output.results,
              });
              console.log(this.state.states);
            } else if (resp.status === 403) {
              localStorage.clear();
              window.location.href = "/";
            } else {
            }
            //movie array
          }).catch((err) => {

            // window.location = "/login"
          });
      } catch (err) {
        // Handle Error Here
        console.error(err);
      }
    };
    // StatesRequest();
    const districtsRequest = async () => {
      try {
        const token = localStorage.getItem("token");
        let url = "";
        this.state.search !== ""
          ? (url =
            "master/geography/district?" +
            "name=" +
            this.state.search +
            "&sortBy=" +
            this.state.sortBy +
            "&limit=" +
            this.state.limit +
            "&page=" +
            this.state.page)
          : (url =
            "master/geography/district?sortBy=" +
            this.state.sortBy +
            "&limit=" +
            this.state.limit +
            "&page=" +
            this.state.page);
        const resp = await axios
          .get(Constants.api + url, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((resp) => {
            //  casetype array

            if (resp.status === 201 && resp.data.result !== 'error') {
              console.log(resp.data.output.results);
              this.setState({
                districts: resp.data.output.results,
              });
              console.log(this.state.districts);
            } else if (resp.status === 403) {
              localStorage.clear();
              window.location.href = "/";
            } else {
            }
            //movie array
          }).catch((err) => {

            // window.location = "/login"
          });
      } catch (err) {
        // Handle Error Here
        console.error(err);
      }
    };
    // districtsRequest();
    const CityRequest = async () => {
      try {
        const token = localStorage.getItem("token");
        let url = "";
        this.state.search !== ""
          ? (url =
            "master/geography/city?" +
            "name=" +
            this.state.search +
            "&sortBy=" +
            this.state.sortBy +
            "&limit=" +
            this.state.limit +
            "&page=" +
            this.state.page)
          : (url =
            "master/geography/city?sortBy=" +
            this.state.sortBy +
            "&limit=" +
            this.state.limit +
            "&page=" +
            this.state.page);
        const resp = await axios
          .get(Constants.api + url, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((resp) => {
            //  casetype array

            if (resp.status === 201 && resp.data.result !== 'error') {
              // console.log(resp.data.output.results);
              this.setState({
                citys: resp.data.output.results,
              });
              // console.log(this.state.states);
            } else if (resp.status === 403) {
              localStorage.clear();
              window.location.href = "/";
            } else {
            }
            //movie array
          }).catch((err) => {

            // window.location = "/login"
          });
      } catch (err) {
        // Handle Error Here
        console.error(err);
      }
    };
    // CityRequest();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.resp !== this.props.resp && this.props.resp?.data?.output) {
      const output = this.props.resp.data.output;
      const resolvedUserType = output.salesUserType || output.userType || '';
      this.setState({
        name: output.name || '',
        email: output.email || '',
        mobile: output.mobile || '',
        password: output.password || '',
        mobileWhatsApp: output.mobileWhatsApp || '',
        designation: output.designation || '',
        doa: output.doa || '',
        marital: output.marital || '',
        sex: output.sex || '',
        parentId: output.parentId || '',
        userType: resolvedUserType,
        salesUserType: resolvedUserType,
        parentType: output.parentType || '',
        userJobTitle: output.userJobTitle || '',
        userRegion: output.userRegion || '',
        userBranch: output.userBranch || '',
        selectedStates: output.sStateId ? output.sStateId.split(',') : [],
        selectedCitys: output.sCityId ? output.sCityId.split(',') : [],
        selectedDistricts: output.sDistrictId ? output.sDistrictId.split(',') : [],
        spincode: output.spincode || '',
        cluster: output.cluster || '',
        territory: output.territory || '',
        zone: output.zone || '',
        headquater: output.headquater || '',
        designation: output.designation || '',
        hqDesignation: output.hqDesignation || '',
      }, () => {
        this.convertToIntegerArray();
        if (resolvedUserType) {
          this.SALESRequest(resolvedUserType);
        }
      });
    }
  }

  SALESRequest = (userType) => {
    let parentType = '';
    if (userType === 'SALES') parentType = 'SALES';
    else if (userType === 'SH') parentType = 'SH';
    else if (userType === 'HO') parentType = 'HO';
    else if (userType === 'ZO') parentType = 'ZO';
    else if (userType === 'RO') parentType = 'RO';
    else parentType = '';


    this.setState({ parentType })
    const currentURL = window.location.pathname;
    const parts = currentURL.split("/");
    let programid = parts.pop();
    programid = parseInt(programid);
    const pathSegments = window.location.pathname.split('/'); // Split the URL path by '/'
    let compid = pathSegments[pathSegments.length - 2];
    try {
      const token = localStorage.getItem("token");
      let url = "";
      this.state.search !== ""
        ? (url =
          "user/manage?" +
          "name=" +
          "state" +
          "&mobile=" +
          "state" +
          "&userType=" + parentType +
          "&sortBy=" +
          "name" +
          "&limit=" +
          "10000" +
          "&page=" +
          "1")
        : (url =
          "user/manage?sortBy=" +
          "name" +
          "&userType=" + parentType +
          "&limit=" +
          "10000" +
          "&page=" +
          "1");
      const resp = axios
        .get(Constants.api + url, {
          headers: {
            Authorization: `Bearer ${token}`, company: compid, program: programid, appVersion: Constants.av,
            platform: Constants.pt
          },

        })
        .then((resp) => {
          //  SALESs array

          if (resp.status === 201 && resp.data.result !== "error") {
            console.log(resp.data.output.results);
            this.setState({
              parents: resp.data.output.results,
            });
            console.log(this.state.members);
          } else if (resp.status === 403) {
            localStorage.clear();
            window.location.href = "/";
          } else {
          }
        }).catch((err) => {
          // window.location = "/login"
        });
    } catch (err) {
      // Handle Error Here
      console.error(err);
    }
  }

  regionsRequest() {
    const currentURL = window.location.pathname;
    const parts = currentURL.split("/");
    let programid = parts.pop();
    programid = parseInt(programid);
    const pathSegments = window.location.pathname.split('/'); // Split the URL path by '/'
    let compid = pathSegments[pathSegments.length - 2];
    const SALESRequest = async () => {

      try {
        const token = localStorage.getItem("token");
        let url = "";
        this.state.search !== ""
          ? (url =
            "program/child/region/region?" +
            "name=" +
            this.state.search +
            "&mobile=" +
            this.state.search +
            "&userType=SALES" +
            "&sortBy=" +
            this.state.sortBy +
            "&limit=" +
            this.state.limit +
            "&page=" +
            this.state.page)
          : (url =
            "program/child/region/region?sortBy=" +
            this.state.sortBy +
            "&userType=SALES" +
            "&limit=" +
            this.state.limit +
            "&page=" +
            this.state.page);
        const resp = await axios
          .get(Constants.api + url, {
            headers: {
              Authorization: `Bearer ${token}`, company: compid, program: programid, appVersion: Constants.av,
              platform: Constants.pt
            },

          })
          .then((resp) => {
            //  SALESs array

            if (resp.status === 201 && resp.data.result !== "error") {
              console.log(resp.data.output.results);
              this.setState({
                regions: resp.data.output.results,
              });
              console.log(this.state.members);
            } else if (resp.status === 403) {
              localStorage.clear();
              window.location.href = "/";
            } else {
            }
          }).catch((err) => {
            // window.location = "/login"
          });
      } catch (err) {
        // Handle Error Here
        console.error(err);
      }
    };
    SALESRequest();
  }
  handleInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.value;

    this.setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  handleRegionChange = (event) => {
    this.setState({ userRegion: event.target.value })
    this.getBranchesbyRegion(event.target.value)
  };
  // handleuserTypeChange = (event) => {
  //   this.setState({ userType: event.target.value }, this.SALESRequest(event.target.value));
  // }
  handleuserTypeChange = (event) => {
    const val = event.target.value;
    this.setState({
      userType: val,
      salesUserType: val,
    }, () => {
      this.SALESRequest(val); // If you need to trigger an API call
    });
  };
  handleBranchChange = (event) => {
    this.setState({ userBranch: event.target.value })
    this.getAreabyBranch(event.target.value)
  };
  handleAreaChange = (event) => {
    this.setState({ userArea: event.target.value })
    this.getCitiesbyArea(event.target.value)
  };
  getBranchesbyRegion = (id) => {
    try {
      const token = localStorage.getItem("token");
      const deletedata = new FormData();
      deletedata.append("id", id); //append the values with key, value pair

      axios
        .get(
          Constants.api + "program/child/region/region/" + id,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
          deletedata
        )
        .then((resp) => {
          //  casetype array

          if (resp.status === 200) {
            this.setState({ create: 1, branches: resp.data.output.branches });
          } else if (resp.status === 403) {
            localStorage.clear();
            window.location.href = "/";
          } else {
          }
          //movie array
        }).catch((err) => {
          // window.location = "/login"
        });
    } catch (err) {
      // Handle Error Here
      console.error(err);
    }
  };
  getAreabyBranch = (id) => {
    try {
      const token = localStorage.getItem("token");
      const deletedata = new FormData();
      deletedata.append("id", id); //append the values with key, value pair

      axios
        .get(
          Constants.api + "program/child/region/branch/" + id,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
          deletedata
        )
        .then((resp) => {
          //  casetype array

          if (resp.status === 200) {
            this.setState({ create: 1, areas: resp.data.output.branches });
          } else if (resp.status === 403) {
            localStorage.clear();
            window.location.href = "/";
          } else {
          }
          //movie array
        }).catch((err) => {
          // window.location = "/login"
        });
    } catch (err) {
      // Handle Error Here
      console.error(err);
    }
  };
  getCitiesbyArea = (id) => {
    try {
      const token = localStorage.getItem("token");
      const deletedata = new FormData();
      deletedata.append("id", id); //append the values with key, value pair

      axios
        .get(
          Constants.api + "program/child/region/area/" + id,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
          deletedata
        )
        .then((resp) => {
          //  casetype array

          if (resp.status === 200) {
            this.setState({ create: 1, cities: resp.data.output.cities.split(',') });
          } else if (resp.status === 403) {
            localStorage.clear();
            window.location.href = "/";
          } else {
          }
          //movie array
        }).catch((err) => {
          // window.location = "/login"
        });
    } catch (err) {
      // Handle Error Here
      console.error(err);
    }
  };
  getCitiesbyArea = (id) => {
    try {
      const token = localStorage.getItem("token");
      const deletedata = new FormData();
      deletedata.append("id", id); //append the values with key, value pair

      axios
        .get(
          Constants.api + "program/child/region/area/" + id,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
          deletedata
        )
        .then((resp) => {
          //  casetype array

          if (resp.status === 200) {
            this.setState({ create: 1, cities: resp.data.output.cities.split(',') });
          } else if (resp.status === 403) {
            localStorage.clear();
            window.location.href = "/";
          } else {
          }
          //movie array
        }).catch((err) => {
          // window.location = "/login"
        });
    } catch (err) {
      // Handle Error Here
      console.error(err);
    }
  };
  handleNestedInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.value;
    const group = target.dataset.group;

    this.setState((prevState) => ({
      ...prevState,
      [group]: {
        ...prevState[group],
        [name]: value,
      },
    }));
  };
  searchHandleChange = (event) => {
    this.setState(
      { search: event.target.value, page: 1 },
      this.componentDidMount()
    );
  };

  handleCommaSeparatedPincodes = (e) => {
    const input = e.target.value;
    const parts = input.split(',').map(p => p.trim());
    const validPincodes = parts.filter(p => /^\d{6}$/.test(p));

    this.setState({
      spincode: input,
      pincodes: validPincodes
    });
  };


  handleFormSubmit = (event) => {
    event.preventDefault();
    if (this.validator.allValid()) {
      this.setState({ submitting: true });
      const token = localStorage.getItem("token");
      const currentURL = window.location.pathname;
      const parts = currentURL.split("/");
      let programid = parts.pop();
      programid = parseInt(programid);
      const pathSegments = window.location.pathname.split('/'); // Split the URL path by '/'
      let compid = pathSegments[pathSegments.length - 2];

      let filteredStates = this.state.selectedStates.filter(value => value !== null && !isNaN(value));
      let filteredCitys = this.state.selectedCitys.filter(value => value !== null && !isNaN(value));
      let filteredDistricts = this.state.selectedDistricts.filter(value => value !== null && !isNaN(value));

      if (this.props.resp) {
        // Get the last second segment

        try {

          axios
            .patch(
              Constants.api + "user/manage/" + this.props.resp.data.output.id,
              {
                "name": this.state.name,
                "email": this.state.email,
                "mobile": this.state.mobile,
                "password": this.state.password,
                "designation": this.state.designation,
                // "dob": this.state.dob,
                // "doa": this.state.doa,
                // "marital": this.state.marital,
                // "sex": this.state.sex,
                "userType": this.state.userType,
                "parentType": this.state.parentType,
                mVerify: true,
                "userJobTitle": this.state.userJobTitle,
                "parentId": this.state.parentId,
                sStateId: filteredStates.join(','),
                sCityId: filteredCitys.join(','),
                sDistrictId: filteredDistricts.join(','),
                "spincode": this.state.spincode,
                "salesUserType": this.state.salesUserType,
                "cluster": this.state.cluster,
                "territory": this.state.territory,
                "zone": this.state.zone,
                "headquater": this.state.headquater,
                "designation": this.state.designation,
                "hqDesignation": this.state.hqDesignation,

              }
              ,

              {
                headers: { Authorization: `Bearer ${token}`, company: compid, program: programid, platform: Constants.pt, appVersion: Constants.av },
              }
            )
            .then((res) => {
              if (res.status === 200) {
                swal(res.data.msg);
                this.onCancelTrigger(0);
              } else if (res.status === 403) {
                localStorage.clear();
                window.location.href = "/";
              } else {
                // this.setState({alert:res.data.msg});
                swal("Something went wrong!");
              }
            })
            .finally(() => {
              this.setState({ submitting: false });
            });
        } catch (err) {
          // Handle Error Here
          console.error(err);
          this.setState({ submitting: false });
        }
      }
      else {
        // Get the last second segment

        try {
          axios
            .post(
              Constants.api + "user/manage",
              {
                "name": this.state.name,
                "email": this.state.email,
                "mobile": this.state.mobile,
                "password": this.state.password,
                "designation": this.state.designation,
                // "dob": this.state.dob,
                // "doa": this.state.doa,
                // "marital": this.state.marital,
                // "sex": this.state.sex,
                "userType": this.state.userType,
                "userJobTitle": this.state.userJobTitle,
                "parentId": this.state.parentId,
                "parentType": this.state.parentType,
                mVerify: true,
                sStateId: filteredStates.join(','),
                sCityId: filteredCitys.join(','),
                sDistrictId: filteredDistricts.join(','),
                "spincode": this.state.spincode,
                "salesUserType": this.state.salesUserType,
                "cluster": this.state.cluster,
                "territory": this.state.territory,
                "zone": this.state.zone,
                "headquater": this.state.headquater,
                "designation": this.state.designation,
                "hqDesignation": this.state.hqDesignation,
              },

              {
                headers: { Authorization: `Bearer ${token}`, company: compid, program: programid, platform: Constants.pt, appVersion: Constants.av },
              }
            )
            .then((res) => {
              if (res.status === 201) {
                swal(res.data.msg);
                // this.setState({ create: 0 })
                this.onCancelTrigger(0);
              }
              else if (res.status === 403) {
                localStorage.clear();
                window.location.href = "/";
              } else {
                // this.setState({alert:res.data.msg});
                swal("Something went wrong!");
              }
            })
            .finally(() => {
              this.setState({ submitting: false });
            });
        } catch (err) {
          // Handle Error Here
          console.error(err);
          this.setState({ submitting: false });
        }
      }
    } else {
      this.setState({ submitting: false });
      this.validator.showMessages();
    }
    this.forceUpdate();
  };
  onCancelTrigger = (event) => {
    this.props.setViewMode(event);
    event.preventDefault();
  }
  //this.onCancelTrigger(0)

  render() {

    if (this.state.create === 0) {
      window.location.reload()
    }


    const handleStateChange = (stateId) => {

      let selectedStates = this.state.selectedStates;
      const index = selectedStates.indexOf(stateId);

      if (index === -1) {

        selectedStates.push(stateId)

      } else {

        selectedStates.splice(index, 1);

      }
      this.setState({
        selectedStates: selectedStates
      })
    };
    const handleDistrictChange = (districtId) => {
      let selectedDistricts = this.state.selectedDistricts;
      const index = selectedDistricts.indexOf(districtId);

      if (index === -1) {
        selectedDistricts.push(districtId)

      } else {
        selectedDistricts.splice(index, 1);

      }
      this.setState({
        selectedDistricts: selectedDistricts
      })
    };

    const handleCityChange = (cityid) => {
      let selectedCitys = this.state.selectedCitys;
      const index = selectedCitys.indexOf(cityid);

      if (index === -1) {

        selectedCitys.push(cityid)

      } else {
        selectedCitys.splice(index, 1);

        // let selectedCitys = selectedCitys.filter((item) => item !== cityid);

      }
      this.setState({
        selectedCitys: selectedCitys
      })
    };
    let selectedCitys = this.state.selectedCitys;
    let selectedStates = this.state.selectedStates;
    let selectedDistricts = this.state.selectedDistricts;

    //  let search = this.state.search;

    return (
      <>

        <main>
          <div class="container-fluid my-3 py-3">
            <div class="row mb-5">

              <div class="col-lg-12 mt-lg-0 mt-4">
                <div class="card card-body" id="profile">
                  <div class="row justify-content-center align-items-center">
                    <div class="col-sm-auto col-4">

                    </div>
                    <div class="col-sm-auto col-8 my-auto">
                      <div class="h-100">
                        <h5 class="mb-1 font-weight-bolder">
                          Program Manager
                        </h5>

                      </div>
                    </div>
                    <div class="col-sm-auto ms-sm-auto mt-sm-0 mt-3 d-flex">

                    </div>
                  </div>
                </div>
                <form >
                  <div class="card mt-4" id="basic-info">
                    <div class="row">
                      <div class="col-6">
                        <div class=" mx-4 input-group-outline my-2">
                          Name
                        </div>
                        <div class=" mx-4 input-group-outline my-2">
                          <input type="text" maxlength="30" name="name" value={this.state.name} class="form-control" onChange={(e) =>
                            this.handleInputChange(e)
                          } />
                          <div style={{ color: 'red' }}>
                            {this.validator.message('name', this.state.name, 'required|alpha_space')}
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class=" mx-4 input-group-outline my-2">
                          Mobile
                        </div>
                        <div class=" mx-4 input-group-outline my-2">
                          <input type="text" maxlength="30" name="mobile" value={this.state.mobile} class="form-control" onChange={(e) =>
                            this.handleInputChange(e)
                          } />
                          <div style={{ color: 'red' }}>
                            {this.validator.message('mobile', this.state.mobile, 'required|numeric|min:10|max:10')}
                          </div>
                        </div>
                      </div>


                    </div>
                    <div class="row">
                      <div class="col-sm-6">
                        <div class=" mx-4 input-group-outline my-2">
                          Email
                        </div>
                        <div class=" mx-4 input-group-outline my-2">
                          <input type="email" maxlength="50" name="email" value={this.state.email} class="form-control" onChange={(e) =>
                            this.handleInputChange(e)
                          } />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="mx-4 input-group-outline my-2">
                          Pincode
                        </div>
                        <div className="mx-4 input-group-outline my-2">
                          <input
                            type="text"
                            name="spincode"
                            value={this.state.spincode}
                            className="form-control"
                            onChange={(e) => this.handleInputChange(e)}
                          />
                        </div>
                      </div>

                    </div>
                    <div class="row">
                      <div class="col-sm-6">
                        <div class=" mx-4 input-group-outline my-2">
                          Sales User Type
                        </div>
                        <div className="mx-4 input-group-outline my-2">
                          <select
                            value={this.state.userType}
                            name="userType"
                            className="form-control"
                            style={{ height: "50px" }}
                            onChange={(e) => this.handleuserTypeChange(e)}
                          >
                            <option value="">Select</option>
                            <option value="SALES">SALES</option>
                            <option value="SH">SH</option>
                            <option value="RO">RO</option>
                            <option value="HO">HO</option>
                            <option value="ZO">ZO</option>
                            <option value="ADMIN">ADMIN</option>
                          </select>
                          <div style={{ color: 'red' }}>
                            {this.validator.message('mobile', this.state.userType, 'required')}
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class=" mx-4 input-group-outline my-2">
                          Parent
                        </div>
                        <div class=" mx-4 input-group-outline my-2">
                          <select
                            value={this.state.parentId}
                            name="parentId"
                            class="form-control"
                            style={{ height: "50px" }}
                            disabled={!this.state.userType}   // 🔥 key line
                            onChange={(e) => this.handleInputChange(e)}
                          >
                            <option value="0">Please select</option>
                            {this.state.parents.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.name}
                              </option>
                            ))}
                          </select>

                        </div>
                      </div>


                    </div>
                    <div class="row">
                      <div class="col-sm-6">
                        <div class=" mx-4 input-group-outline my-2">
                          Cluster
                        </div>
                        <div class=" mx-4 input-group-outline my-2">
                          <input type="text" maxlength="50" name="cluster" value={this.state.cluster} class="form-control" onChange={(e) =>
                            this.handleInputChange(e)
                          } />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="mx-4 input-group-outline my-2">
                          Territory
                        </div>
                        <div className="mx-4 input-group-outline my-2">
                          <input
                            type="text"
                            name="territory"
                            value={this.state.territory}
                            className="form-control"
                            onChange={(e) => this.handleInputChange(e)}
                          />
                        </div>
                      </div>

                    </div>
                    <div class="row">
                      <div class="col-sm-6">
                        <div class=" mx-4 input-group-outline my-2">
                          Zone
                        </div>
                        <div class=" mx-4 input-group-outline my-2">
                          <input
                            type="text"
                            maxlength="30"
                            name="zone"
                            value={this.state.zone}
                            class="form-control"
                            onChange={(e) => this.handleInputChange(e)}
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="mx-4 input-group-outline my-2">
                          Headquarter
                        </div>
                        <div className="mx-4 input-group-outline my-2">
                          <input
                            type="text"
                            maxlength="30"
                            name="headquater"
                            value={this.state.headquater}
                            className="form-control"
                            onChange={(e) => this.handleInputChange(e)}
                          />
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-6">
                        <div class=" mx-4 input-group-outline my-2">
                          Designation
                        </div>
                        <div class=" mx-4 input-group-outline my-2">
                          <input
                            type="text"
                            maxlength="30"
                            name="designation"
                            value={this.state.designation}
                            class="form-control"
                            onChange={(e) => this.handleInputChange(e)}
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="mx-4 input-group-outline my-2">
                          HQ Designation
                        </div>
                        <div className="mx-4 input-group-outline my-2">
                          <input
                            type="text"
                            maxlength="30"
                            name="hqDesignation"
                            value={this.state.hqDesignation}
                            className="form-control"
                            onChange={(e) => this.handleInputChange(e)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card mt-4" id="basic-info">

                  </div>


                  <div class="card mt-4" id="delete">
                    <div class="card-body">
                      <div class="d-flex align-items-center mb-sm-0 mb-4">
                        <div class="w-50">
                          <h5>Save Manager</h5>
                        </div>
                        <div class="w-50 text-end">
                          <button class="btn btn-outline-secondary mb-3 mb-md-0 ms-auto" type="button" name="button" onClick={() => this.onCancelTrigger(0)}>Cancel</button>
                          <LoadingButton class="btn bg-gradient-success mb-0 ms-2" type="submit" name="button" loading={this.state.submitting} onClick={this.handleFormSubmit}>Save </LoadingButton>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>


          </div>
        </main >
      </>
    );
  }

}

export default CreateProgramManagers;
